import { getAuth } from 'firebase/auth';

/**
 * Get Firebase auth token for API authentication
 */
async function getAuthToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  return await user.getIdToken();
}

/**
 * Get current user ID
 */
export function getCurrentUserId() {
  const auth = getAuth();
  return auth.currentUser?.uid || null;
}

export async function uploadDocument(file, clientId, linkId, fileId, fileName) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('clientId', clientId);
    formData.append('linkId', linkId);
    formData.append('fileId', fileId);
    formData.append('fileName', fileName);

    const API_BASE = process.env.REACT_APP_API_URL;
    const response = await fetch(`${API_BASE}/upload-file`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json();
      // Handle specific error cases
      switch (response.status) {
        case 400:
          throw new Error(data.error || 'Invalid request parameters');
        case 404:
          throw new Error(data.error || 'Link not found');
        case 429:
          throw new Error(data.error || 'File limit reached for this link');
        case 500:
          throw new Error(data.error || 'Error uploading file');
        default:
          throw new Error(data.error || 'Error uploading file');
      }
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

/**
 * Upload criterio document with authentication
 */
export async function uploadCriterioDocument(file, afianzadoraName) {
  try {
    const token = await getAuthToken();
    const userId = getCurrentUserId();
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('afianzadoraName', afianzadoraName);
    formData.append('userId', userId);

    const API_BASE = process.env.REACT_APP_API_URL;
    const response = await fetch(`${API_BASE}/upload-criterio-file`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

/**
 * Reprocess an existing file without re-uploading
 * Requires Firebase authentication
 */
export async function reprocessFile(clientId, linkId, fileId, timestamp) {
  try {
    const token = await getAuthToken();
    const API_BASE = process.env.REACT_APP_API_URL;
    const response = await fetch(`${API_BASE}/reprocess-file`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientId,
        linkId,
        fileId,
        timestamp
      }),
    });

    if (!response.ok) {
      const data = await response.json();
      // Handle specific error cases
      switch (response.status) {
        case 400:
          throw new Error(data.error || 'Invalid request parameters or missing required fields');
        case 401:
          throw new Error(data.error || 'Authentication failed - invalid or expired token');
        case 403:
          throw new Error(data.error || 'Access denied - user does not have access to this resource');
        case 404:
          throw new Error(data.error || 'Link document or file not found');
        case 500:
          throw new Error(data.error || 'Error reprocessing file');
        default:
          throw new Error(data.error || 'Error reprocessing file');
      }
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}